import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { EncrDecrService } from './../../services/encr-decr.service';


@Component({
  selector: 'app-s-view-customer',
  templateUrl: './s-view-customer.component.html',
  styleUrls: ['./s-view-customer.component.css']
})
export class SViewCustomerComponent implements OnInit {

  user_id: any = '';
  token: any = '';
  APIKEY: any = 'SOAV2@123';
  buttonDisabled: boolean;
  model: any = {};
  myDateValue: Date;
  factLanguage: any = {};
  arr: any[] = [];
  key_info: any = {};
  company_id: any = 0;
  edit_factoring_mode: boolean = false;
  modelexpiration_date: any = '';
  submitForm: FormGroup;
  noticeOfAssignmentDoc: any;
  factReadOnly: boolean = true;
  showpdficon: string;
  loaderMode = false;
  notice_of_assignment_doc_path_old: any;
  invoice_number: any;
  modified_by: any;
  modified_at: any;
  created_at: any;
  created_by: any;
  DynamicError: boolean;
  showdoc: string;

  constructor(private _company: CompanyService,
    private _factLang: FactLanguageService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,
    private formbuilder: FormBuilder,
  ) { }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }
  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.token = localStorage.getItem('token');

    this._activatedroute.params.subscribe(params => {
      this.company_id = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });

    // this._activatedroute.params.subscribe(params => {
    //   this.company_id = params['id'];
    // });

    this.get_company_by_id();

    this.myDateValue = new Date();
    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [this.company_id],
      dynamicFields: this.formbuilder.array([]),
      advance_rate: '',
      inv_number: '',
      modified_by: '',
      modified_at: '',
      created_at: '',
      created_by: ''
    });
    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      account_id: [0],
      is_primary_account: [true, Validators.required],
      account_name: [''],
      account_number: [''],
      description: [''],
      ach: [true],
      wire: [false],

    });
    // this.dynamicFields.push(dynamicFieldForm);
  }

  onSubmit(form) {

    this.model["company_id"] = this.company_id;
    this.model["APIKEY"] = this.APIKEY;
    //console.log(this.model);  return false;   
    this._company.updateCmp(this.model)
      .subscribe(
        res => {
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
          }
          else {
            this.toastr.error(res.message, 'Error');
          }
          this._router.navigate(['super-admin/customer-list']);
        },
      );
  }

  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }
    this._company.getCompanyById(data)
      .subscribe(
        res => {
          if (res.dataAccount.length > 0) {
            this.dynamicFields.removeAt(0);
            for (let item of res.dataAccount) {
              if (item.is_ach == 0) {
                item.is_ach = false;
              } else {
                item.is_ach = true;
              }
              if (item.is_wire == 0) {
                item.is_wire = false;
              } else {
                item.is_wire = true;
              }
              const dynamicFieldForm = this.formbuilder.group({
                id: [0],
                account_id: item.account_id,
                is_primary_account: (item.is_primary_account == 1) ? true : false,
                account_name: item.account_name,
                account_number: item.account_number,
                description: item.description,
                ach: item.is_ach,
                wire: item.is_wire,
              });


              this.dynamicFields.push(dynamicFieldForm);
            }
          }

          if (res.data.edit_factoring == 1) {
            this.edit_factoring_mode = true;
            this.factReadOnly = false;
          }
          // console.log(res.data.notice_of_assignment_doc_path);
          if (res.data.notice_of_assignment_doc_path == null || res.data.notice_of_assignment_doc_path == '') {

            this.model["notice_of_assignment_doc_path"] = '';
            this.showpdficon = 'no';
            this.notice_of_assignment_doc_path_old = '';
          } else {
            this.showpdficon = 'yes';
            this.model["notice_of_assignment_doc_path"] = res.data.notice_of_assignment_doc_path;
            this.notice_of_assignment_doc_path_old = res.data.notice_of_assignment_doc_path;
          }
          if (res.data.advance_rate == null) {
            // this.submitForm.get('dynamicFields').setValue('');
          } else {
            this.submitForm.get('advance_rate').setValue(res.data.advance_rate);

          }
          this.model = res.data;
          if (this.model["acc_email"] == 'undefined') {
            this.model["acc_email"] = '';
          }
          if (this.model["cc_email"] == 'undefined') {
            this.model["cc_email"] = '';
          }
          if (this.model["notification_email"] == 'undefined') {
            this.model["notification_email"] = '';
          }
          this.model.password = this.EncrDecr.get(localStorage.getItem('key'), this.model.password);

        },
        err => console.log(err)
      );
  }

}
